import React, { useMemo, useState } from 'react';
import { useAuth } from '@/lib/AuthContext';
import { getDisplayMessage } from '@/api/apiClient';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { toast } from 'sonner';

/**
 * Empresas com o mesmo e-mail sem bloqueio de pagamento/cadastro: troca a sessão (novo JWT).
 */
export default function TrocarEmpresaConta({ className = '' }) {
  const { empresa, empresasVinculadas, switchEmpresa } = useAuth();
  const [busy, setBusy] = useState(false);

  const outros = useMemo(() => {
    const alvos = (empresasVinculadas || []).filter((x) => x.podeTrocar);
    return alvos.filter((x) => x.empresaId !== empresa?.id);
  }, [empresasVinculadas, empresa?.id]);

  if (outros.length === 0) return null;

  const onPick = async (empresaId) => {
    if (!empresaId || empresaId === empresa?.id) return;
    setBusy(true);
    try {
      await switchEmpresa(empresaId);
    } catch (e) {
      toast.error(getDisplayMessage(e, 'Não foi possível trocar de empresa.'));
      setBusy(false);
    }
  };

  return (
    <div className={className}>
      <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider px-3 mb-2 block">
        Acessar outra empresa
      </label>
      <Select disabled={busy} onValueChange={(id) => onPick(id)}>
        <SelectTrigger className="w-full">
          <SelectValue placeholder={busy ? 'Entrando…' : 'Selecione a empresa'} />
        </SelectTrigger>
        <SelectContent>
          {outros.map((row) => (
            <SelectItem key={row.empresaId} value={row.empresaId}>
              {row.nome}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
